import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  Box,
  useMediaQuery,
  useTheme,
  TextField,
  IconButton,
} from "@mui/material";
import ButtonComp from "./Button";
import CloseIcon from "@mui/icons-material/Close";

type CloseClaimPopupProps = {
  open: boolean;
  onClose: () => void;
  handleCloseClaim: () => void;
  onChange: (value: any) => void;
  closeReason: any;
};

const CloseClaimPopup = (props: CloseClaimPopupProps) => {
  const { open, onClose, handleCloseClaim, onChange, closeReason } = props;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const label = "Provide a reason to close the claim";

  const isReasonEmpty = closeReason.trim() === "";

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="otp-dialog-title"
      aria-describedby="otp-dialog-description"
      slotProps={{
        paper: {
          sx: {
            // width: 500,
            width: 450,
            height: 450,
            borderRadius: 4,
            overflow: "hidden",
          },
        },
      }}
    >
      <Box
        sx={{
          backgroundColor: "primary.main",
          height: 70,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      ></Box>

      <DialogContent
        sx={{
          backgroundColor: theme.palette.background.default,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          gap={4}
          sx={{
            width: {
              xs: "90%",
              sm: "80%",
              md: "90%",
            },
          }}
        >
          <Typography fontSize={25} fontWeight={600} textAlign="center">
            {label}
          </Typography>

          <TextField
            label="Reason"
            multiline
            rows={5}
            fullWidth
            variant="outlined"
            value={closeReason}
            onChange={(e) => onChange(e.target.value)}
          />

          <Box
            display="flex"
            justifyContent="center"
            // gap={6}
            sx={{ gap: { xs: 2, sm: 3, md: 6 } }}
            width="100%"
          >
            <ButtonComp
              variant="contained"
              height={40}
              width={140}
              onClick={() => {
                handleCloseClaim();
                onClose();
              }}
              color="primary"
              textTransform="none"
              disabled={isReasonEmpty}
            >
              Close
            </ButtonComp>
            <ButtonComp
              variant="contained"
              height={40}
              width={140}
              onClick={onClose}
              color="primary"
              textTransform="none"
            >
              Cancel
            </ButtonComp>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default CloseClaimPopup;
